"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.justCookbookFragment = void 0;
const client_1 = require("@apollo/client");
exports.justCookbookFragment = client_1.gql `
  fragment justCookbook on Cookbook {
    __typename
    id
    name
    privacy
    shareId
    owner
    position
    pictureUrl
    coverDetails {
      c1
      c2
      c3
      ac
      svgPatternKey
      coverStyleKey
      fontColor
      acOpacity
      bgColor
      bottomText
      fontFamily
    }
  }
`;
//# sourceMappingURL=cookbook.js.map